import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss'],
  providers:[DatePipe]
})
export class CertificateComponent implements OnInit {
  profileDetails: any={};
  name:any;
  today:any;
  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogref: MatDialogRef<CertificateComponent>, public datePipe: DatePipe) { }

  ngOnInit(): void {
    this.name = JSON.parse(localStorage.getItem('vprpinfo'));
    this.profileDetails.village = this.data.data.village_desc;
    this.profileDetails.Panchayat = this.data.data.panchayat_desc;
    this.profileDetails.block = this.data.data.block_desc;
    this.profileDetails.id = this.data.data.pg_id;
    this.profileDetails.pgName = this.data.data.pg_name;
    const date = new Date();
    this.today = this.datePipe.transform(date, 'dd-MM-yyyy')
  }

}
